import { Component, Input } from "@angular/core";
import { CollectedMagicCard } from "@apiserver-rest/ponder-data-client-base";
import { MagicCardLegalityComponent } from "./magic-card-legality.component";
import { MagicCardLinksComponent } from "./magic-card-links.component";
import { MagicCardRulingsComponent } from "./magic-card-rulings.component";
import { FormatCurrencyPipe } from "@ponder-shared/pipes/format-currency.pipe";

@Component({
    selector: "magic-card-details",
    imports: [MagicCardLegalityComponent, MagicCardLinksComponent, MagicCardRulingsComponent, FormatCurrencyPipe],
    templateUrl: "./magic-card-details.component.html"
})
export class MagicCardDetailsComponent {
    @Input({ required: true }) public username?: string;
    @Input({ required: true }) public collectedMagicCard!: CollectedMagicCard;
    
    constructor() {

    }

    public ngOnInit(): void {
    }

    public hasNormalPrice(): boolean {
        return this.collectedMagicCard!.price.normalUSD > 0;
    }

    public hasSpecialPrice(): boolean {
        return this.collectedMagicCard!.price.specialUSD > 0;
    }

    public getTreatmentList(): string {
        var treatments: string[] = [];

        if (this.collectedMagicCard.card!.treatment.normal) {
            treatments.push("Normal");
        }

        var hasSpecialFoil = this.collectedMagicCard.card!.treatment.other?.some(s => s.includes("Foil")) ?? false;

        if (this.collectedMagicCard.card!.treatment.special && !hasSpecialFoil) {
            treatments.push("Foil"); // Traditional foil
        }

        if (this.collectedMagicCard.card!.treatment.other) {
            treatments.push(... this.collectedMagicCard.card!.treatment.other);
        }

        return treatments.join(", ") ?? "";
    }
}